'use strict';

import Vue from 'vue';
import App from './App.vue';

// Scroll to behavior
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo);

// Inview detector
import VueWaypoint from 'vue-waypoint';
Vue.use(VueWaypoint);

// v-img
import VueImg from 'v-img';
Vue.use(VueImg);

import '@morioh/v-lightbox/dist/lightbox.css';
import Lightbox from '@morioh/v-lightbox';
Vue.use(Lightbox);

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import './assets/css/reset.css';
import './assets/css/font-awesome/css/font-awesome.min.css';

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app');
